export const IS_CCP_BILLING_ADMIN = 'jira_family_standard_and_premium_is_ccp_billing_admins';
